import * as TankManagementActions from "../actions/tankmanagement.actions";

const initialState: any = null;

export function tankManagementReducer(
  state: any = initialState,
  action: TankManagementActions.Actions) {
    switch (action.type) {
      case TankManagementActions.SET_CURRENT_TANK:
        if (action.currentTank) return action.currentTank;
        break;
      default:
        return state;
    }
  return state;
}
